/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { Button, ButtonTheme } from '@cian/button-component';

import * as styles from './Header.css';

interface IHeaderProps {
  title: string;
  showAllUrl: string;
  onClickShowAllButton(): void;
}

export const Header: React.FC<IHeaderProps> = ({ title, showAllUrl, onClickShowAllButton }) => {
  return (
    <div className={styles.root}>
      <span className={styles.title}>{title}</span>

      <Button theme={ButtonTheme.Ghost} className={styles.button} onClick={onClickShowAllButton}>
        <a href={showAllUrl} target="_blank" className={styles['show-all-link']}>
          Посмотреть все объявления
        </a>
      </Button>
    </div>
  );
};
